/**
 * Routes that must never be indexed: the admin console and the customer portal (seo-tags-audit-20261024 B1, ACTIONS.csv
 * row "/admin/* (11) and portal shells": they answered HTTP 200 anonymously with no <meta name="robots"> and a
 * self-canonical in ssr-data). AdminLayout does set a robots meta, but the admin and portal pages are
 * dynamic(..., { ssr: false }) shells, so that tag exists only after hydration and the static HTML Googlebot fetches
 * has none. pages/_app.tsx renders the meta at build time from this predicate.
 *
 * Decided from the Next route pathname (`/admin/users/[userId]`) so dynamic routes and the three portal pages without
 * getStaticProps are covered; pageProps.url / pageProps.path are the fallback for the SSG props the pages do pass.
 * /downloads keeps its own hardcoded rule in _app.tsx; feature pages are never matched (scripts/lint-noindex.cjs in
 * xconvert-web-ssr guards the page-data side).
 */
export const NON_PUBLIC_ROUTE = /^\/?(admin|portal)(\/|$)/;

export function isNonPublicRoute(pathname: string | undefined | null, pageProps?: { url?: string; path?: string } | null): boolean {
    return [pathname, pageProps?.url, pageProps?.path].some(v => typeof v === 'string' && NON_PUBLIC_ROUTE.test(v));
}
